export const ATTRIBUTE_FORMAT = 'format';
export const ATTRIBUTE_LOCALE = 'locale';
export const ATTRIBUTE_DATE = 'data-date';
export const ATTRIBUTE_START_FORMAT = 'data-start-format';
export const EVENT_ATTRIBUTE_UPDATED = 'bnum-date:attribute-updated';
export const EVENT_ATTRIBUTE_UPDATED_FORMAT =
  'bnum-date:attribute-updated:format';
export const EVENT_ATTRIBUTE_UPDATED_LOCALE =
  'bnum-date:attribute-updated:locale';
export const EVENT_DATE = 'bnum-date:date';
export const DEFAULT_FORMAT = 'dd/MM/yyyy HH:mm';
export const DEFAULT_LOCALE = 'fr';
export const STATE_INVALID = 'invalid';
export const STATE_NOT_READY = 'not-ready';
